import { registerQuery } from 'data-fetching-client';
import userInfo from 'hub-http/userInfo';
export const GET_USER_INFO = registerQuery({
  fieldName: 'userInfo',
  fetcher() {
    return userInfo();
  }
});